import { graphql } from "../gql";

export const setClaimTechDenialsMutationDoc = graphql(`
  mutation setClaimTechDenials($input: SetClaimTechDenialsInput!) {
    setClaimTechDenials(input: $input) {
      id
      batchClaimStateById {
        id
        techDenied
      }
    }
  }
`);
